webpackJsonp([11],{

/***/ "Y6FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consumo"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":"Gastos e Consumos"}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra informações sobre o consumo de recursos nas\n          unidades municipais.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Os indicadores de gastos têm o objetivo de monitorar o consumo de\n          água e luz. Os dados de água são computados por m³, R$ e por\n          PDE/RGI.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          No ano de "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.ano))]),_vm._v(", foi gasto com água um total de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.valoresAgua))]),_vm._v(" e com luz um\n          total de "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.valoresLuz))]),_vm._v(".\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._l((_vm.graficos),function(item,index){return _c('div',{key:'grafico-' + index,staticClass:"form-group"},[_c('grafico-consumo',{attrs:{"title":item.title,"reference":item.reference,"values":item.values,"keyValue":item.keyValue,"money":item.money,"unidades":item.unidades}})],1)})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kT7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("n1Yr");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f34faa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Y6FB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f34faa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "n1Yr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    GraficoConsumo: __WEBPACK_IMPORTED_MODULE_4__components__["u" /* GraficoConsumo */]
  },
  data: function data() {
    return {
      ano: new Date().getFullYear(),
      breadcrumb: [{
        label: 'Gastos e Consumo'
      }],
      listaAgua: [],
      secretariasAgua: [],
      listaEletricidade: [],
      secretariasEletricidade: []
    };
  },
  created: function created() {
    this.getValoresTipoConta({
      url: 'consumo/agua',
      key: 'listaAgua',
      keySecretaria: 'secretariasAgua'
    });

    this.getValoresTipoConta({
      url: 'consumo/eletricidade',
      key: 'listaEletricidade',
      keySecretaria: 'secretariasEletricidade'
    });
  },

  methods: {
    getValoresTipoConta: function getValoresTipoConta(options) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, key, keySecretaria;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = options.url, key = options.key, keySecretaria = options.keySecretaria;
                _context.next = 3;
                return _this.requestGet({ url: url, key: key });

              case 3:
                _this.getSecretarias({ key: key, keySecretaria: keySecretaria });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    requestGet: function requestGet(options) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, key, params;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = options.url, key = options.key, params = options.params;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get(url, { params: params }).then(function (response) {
                  var data = response.data;

                  _this2[key] = data;
                }).catch(function (error) {
                  console.log(error.response);
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSecretarias: function getSecretarias(options) {
      var key = options.key,
          keySecretaria = options.keySecretaria;

      var unique = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this[key].filter(function (item) {
        return item.codigo_secretaria !== null;
      }).map(function (item) {
        return item.codigo_secretaria;
      }))));

      this.requestGet({
        url: 'unidade-organizacional/secretarias',
        key: keySecretaria,
        params: { ids: unique }
      });
    },
    getValoresTotaisTipoConta: function getValoresTotaisTipoConta(options) {
      var _this3 = this;

      var key = options.key;

      var filter = function filter(item) {
        return parseInt(item.ano_ref) === _this3.ano;
      };
      var reducer = function reducer(anterior, _ref) {
        var valor = _ref.valor;

        return anterior + parseFloat(valor);
      };

      var valor = this[key].filter(filter).reduce(reducer, 0);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* formatarMoeda */])(valor);
    }
  },
  computed: {
    valoresAgua: function valoresAgua() {
      return this.getValoresTotaisTipoConta({ key: 'listaAgua' });
    },
    valoresLuz: function valoresLuz() {
      return this.getValoresTotaisTipoConta({ key: 'listaEletricidade' });
    },
    graficos: function graficos() {
      return [{
        title: 'Total de água em R$ por mês',
        reference: 'grafico-agua-valor',
        values: this.listaAgua,
        keyValue: 'valor',
        money: true,
        unidades: this.secretariasAgua
      }, {
        title: 'Total de água em m³ por mês',
        reference: 'grafico-agua-m3',
        values: this.listaAgua,
        keyValue: 'leitura_m3',
        money: false,
        unidades: this.secretariasAgua
      }, {
        title: 'Total de eletricidade em R$ por mês',
        reference: 'grafico-eletricidade-valor',
        values: this.listaEletricidade,
        keyValue: 'valor',
        money: true,
        unidades: this.secretariasEletricidade
      }, {
        title: 'Total de eletricidade em MW por mês',
        reference: 'grafico-eletricidade-mw',
        values: this.listaEletricidade,
        keyValue: 'leitura_mw',
        money: false,
        unidades: this.secretariasEletricidade
      }];
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.e9a7e4053e24409dfd77.js